const getItemId = item => item?.id?.toString?.() || item?.id;

const getRowItem = row => (row?.type === 'item' ? row.item : row);

export const isCategoryMenuEvent = event =>
  Boolean(
    event?.target?.closest?.('.swimlane-item__options, .app-dropdown-menu')
  );

export const getCategoryMenuItems = ({ clickedItem, selectedRows }) => {
  const clickedItemId = getItemId(clickedItem)?.toString();
  const selectedItems = (selectedRows || []).map(getRowItem).filter(Boolean);
  const clickedItemIsSelected = selectedItems.some(
    item => getItemId(item)?.toString() === clickedItemId
  );

  return selectedItems.length > 1 && clickedItemIsSelected
    ? selectedItems
    : [clickedItem].filter(Boolean);
};

export const insertCategoryRowsAdjacent = ({
  rows,
  insertedRowsByTargetId,
  placement,
}) =>
  (rows || []).flatMap(row => {
    const rowItem = getRowItem(row);
    const insertedRow =
      insertedRowsByTargetId?.[getItemId(rowItem)?.toString()];

    if (!insertedRow) return [row];
    return placement === 'above' ? [insertedRow, row] : [row, insertedRow];
  });

export const getCategoryMenuOptionLabel = ({ option, targetCount }) => {
  if (targetCount <= 1) return option?.label;

  switch (option?.value) {
    case 'duplicate-item':
      return `Duplicate ${targetCount} Categories`;
    case 'add-sub-category':
      return `Add Subcategory to ${targetCount} Categories`;
    case 'delete-item':
      return `Delete ${targetCount} Categories`;
    case 'add-category-above':
      return 'Add Category Above Each';
    case 'add-category-below':
      return 'Add Category Below Each';
    default:
      return option?.label;
  }
};
